"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectSlidersValues = exports.selectSelectedUpsellProducts = exports.selectSelectedUpsellProductOfferings = exports.selectSelectedInsuranceId = exports.selectDisplayedUpsellProductDetails = exports.selectConnectivityPlan = void 0;
const selectSelectedUpsellProducts = instanceId => state => state.drools[instanceId].upsell.selectedUpsellProducts;
exports.selectSelectedUpsellProducts = selectSelectedUpsellProducts;
const selectSelectedUpsellProductOfferings = instanceId => state => {
  const names = [];
  Object.values(state.drools[instanceId].upsell.selectedUpsellProducts).forEach(category => {
    category.forEach(name => names.push(name));
  });
  return state.drools[instanceId].productCatalog.productRelationshipOffering.filter(product => {
    return names.includes(product.id);
  });
};
exports.selectSelectedUpsellProductOfferings = selectSelectedUpsellProductOfferings;
const selectSelectedInsuranceId = instanceId => state => state.drools[instanceId].upsell.selectedUpsellProducts.insurance;
exports.selectSelectedInsuranceId = selectSelectedInsuranceId;
const selectDisplayedUpsellProductDetails = instanceId => state => state.drools[instanceId].upsell.displayedUpsellProductDetails;
exports.selectDisplayedUpsellProductDetails = selectDisplayedUpsellProductDetails;
const selectConnectivityPlan = instanceId => state => state.drools[instanceId].upsell.connectivityPlan;
exports.selectConnectivityPlan = selectConnectivityPlan;
const selectSlidersValues = instanceId => state => state.drools[instanceId].upsell.slidersValues;
exports.selectSlidersValues = selectSlidersValues;